/* Casa Coton — sélecteur de variantes accordéon (amélioration progressive).
   Les <details>/<summary> natifs gèrent seuls l'ouverture/fermeture ;
   ce script se contente de :
   - garder un seul panneau ouvert à la fois ;
   - refléter l'état sur aria-expanded pour les lecteurs d'écran.
   Délégation au niveau du document : continue de fonctionner après chaque
   re-rendu de <variant-selects> par product-info.js (Dawn 16). */
(function () {
  'use strict';

  function syncSummary(details) {
    var summary = details.querySelector('summary.cc-opt__summary');
    if (summary) summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
  }

  document.addEventListener(
    'toggle',
    function (event) {
      var details = event.target;
      if (!(details instanceof HTMLElement) || !details.classList || !details.classList.contains('cc-opt')) return;
      syncSummary(details);
      if (!details.open) return;
      var picker = details.closest('variant-selects');
      if (!picker) return;
      picker.querySelectorAll('details.cc-opt[open]').forEach(function (other) {
        if (other !== details) other.open = false;
      });
    },
    true
  );
})();
